module.exports = __webpack_public_path__ + "img/jnmh_01.102d38dc.jpg";